import React, { Component } from 'react';
import { ServerSideImplementation } from './ServerSideImplementation';

export class ServerSide extends Component {
    displayName = ServerSide.name;

    constructor(props) {
        super(props);
    }

    name = 'ServerSide';

    handleClick = (e) => {
        e.preventDefault();
        const { handleClick } = this.props;
        handleClick(this.name);
    }

    render() {
        let _active = this.props.active === this.name;

        let classes = "c-category__link is-revealable";

        if (_active)
            classes += " is-active";

        return (
            <li key="serverside" className="g-panel__item">
                <a href="#" className={classes} onClick={this.handleClick}>Server side</a>
                <ServerSideImplementation
                    active={_active}
                    selectedProperties={this.props.selectedProperties}
                    hiddenProperties={this.props.hiddenProperties}
                    resource={this.props.resource}
                    handleClick={this.props.handleClick}
                    examples={this.props.examples}
                />
            </li>
        );
    }
}